import {Injectable} from '@angular/core';
import {AppConfigService} from "../config/app-config.service";

const TOKEN_KEY = 'auth-token';
const REFRESH_TOKEN = 'refresh-token';
const USER_KEY = 'user';
const USER_TYPE = 'user-type';
const USER_ENV = 'user-env';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  userType = "";

  constructor() {

  }



  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  public saveRefreshToken(token: string): void {
    window.localStorage.removeItem(REFRESH_TOKEN);
    window.localStorage.setItem(REFRESH_TOKEN, token);
  }

  public getRefreshToken(): string | null {
    return window.localStorage.getItem(REFRESH_TOKEN);
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public saveUserType(userType: string): void {
    window.localStorage.setItem(USER_TYPE, userType);
  }

  public getUserType(): string | null {
    return window.localStorage.getItem(USER_TYPE);
  }

  public saveUserEnv(userEnv: string): void {
    window.localStorage.setItem(USER_ENV, userEnv);
  }

  public getUserEnv(): string | null {
    return window.localStorage.getItem(USER_ENV);
  }
}
